export default __webpack_public_path__ + "static/media/k3ibl.84773894.png";